import Vue from 'vue'
import VueI18n from 'vue-i18n'
import elementEnLocale from 'element-ui/lib/locale/lang/en'
import elementZhLocale from 'element-ui/lib/locale/lang/zh-CN'

Vue.use(VueI18n)

const messages = {
  en: {
    ...elementEnLocale,
    nav: {
      home: 'Home',
      dataModule: 'Data Module',
      dataOverview: 'Data Overview',
      sampleMetadata: 'Sample Metadata',
      assemblyQuality: 'Assembly Quality',
      taxonomicProfile: 'Taxonomic Profile',
      dataMonitoring: 'Data Monitoring',
      functionModule: 'Function Module',
      qualityAssessment: 'Quality Assessment',
      speciesAnnotation: 'Species Annotation',
      structuralAnnotation: 'Structural Annotation',
      functionalAnnotation: 'Functional Annotation',
      resourceSharing: 'Resource Sharing',
      userManual: 'User Manual',
      contact: 'Contact',
      searchPlaceholder: 'Quick Search...',
      subtitle: 'Wildlife High-quality Metagenome-Assembled Genomes'
    },
    assemblyQuality: {
      title: 'Assembly Statistics',
      subtitle: 'Overview of MAG quality metrics',
      totalMAGs: 'Total MAGs',
      qualityLevel: 'Quality Level',
      magQuality: 'MAG Quality',
      avgCompleteness: 'Avg Completeness',
      hostSpecies: 'Host Species',
      high: 'High',
      medium: 'Medium',
      low: 'Low',
      chartsTitle: 'Quality Visualization',
      chartsSubtitle: 'Distribution and correlation analysis',
      chartDistTitle: 'Quality Level Distribution',
      chartScatterTitle: 'Completeness vs Contamination',
      filterTitle: 'Search & Filter MAGs',
      filterSubtitle: 'Find specific MAGs by assembly metrics',
      searchPlaceholder: 'Search by Genome ID, R_Genome ID, Sample ID, Host...',
      searchBtn: 'Search',
      rGenomeId: 'R_Genome ID',
      selectId: 'Select ID',
      selectHost: 'Select Host',
      qualityLevels: 'Quality Levels',
      highQuality: 'High Quality',
      completeness: 'Completeness',
      contamination: 'Contamination',
      genomeSize: 'Genome Size (Mb)',
      gcContent: 'GC Content (%)',
      resetFilters: 'Reset Filters',
      exportSelected: 'Export Selected',
      tableTitle: 'Assembly Results',
      total: 'Total: {total} MAGs',
      selected: 'Selected: {count}',
      all: 'All',
      none: 'None',
      favorites: 'Favorites',
      colSampleID: 'Sample ID',
      colHost: 'Host',
      colCompleteness: 'Completeness',
      colContamination: 'Contamination',
      colQuality: 'Quality',
      colN50: 'N50 (bp)',
      colSize: 'Size (Mb)',
      colGC: 'GC (%)',
      colActions: 'Actions',
      btnDetails: 'Details',
      btnAddFavorite: 'Add Favorite',
      btnTaxonomy: 'Taxonomy',
      dialogDetailTitle: 'MAG Assembly Details',
      btnDownloadFASTA: 'Download FASTA',
      btnFavorite: 'Favorite',
      tabQuality: 'Assembly Quality',
      tabMetrics: 'Assembly Metrics',
      metaPrimary: 'Primary Metadata',
      metaGenomeID: 'Genome ID:',
      metaSampleID: 'Sample ID:',
      metaHost: 'Host Species:',
      metricN50: 'Contig N50',
      metricMaxContig: 'Max Contig',
      metricTotalContigs: 'Total Contigs',
      metricTotalCDS: 'Total CDS',
      metricCodingDensity: 'Coding Density',
      metricAvgGeneLength: 'Avg Gene Length',
      dialogFavTitle: 'My Favorite MAGs',
      btnExportCSV: 'Export CSV',
      btnClearAll: 'Clear All',
      colAdded: 'Added',
      btnView: 'View',
      btnRemove: 'Remove',
      msgLoadError: 'Failed to load MAG data',
      msgAddedFavorite: 'Added to favorites'
    },
    taxonomicProfile: {
      titleConfirm: 'Confirm Clear',
      dialogName: 'Name',
      classifiedMAGs: 'Classified MAGs',
      unclassifiedMAGs: 'Unclassified MAGs',
      taxonomicCoverage: 'Taxonomic Coverage',
      speciesLevel: 'Species Level',
      msgLoadError: 'Failed to load taxonomic data',
      msgInitError: 'Page initialization failed, please refresh',
      msgLoadStatsError: 'Failed to load statistics',
      msgNoData: 'No data available',
      msgExporting: 'Preparing to export taxonomic annotation data...',
      msgExportNoData: 'No data matching the conditions to export',
      msgExportSuccessCount: 'Successfully exported {count} taxonomic annotation records',
      msgExportError: 'Failed to get export data',
      msgExportFuncError: 'Export function error',
      msgCSVError: 'Failed to generate CSV file',
      colAdditionalNotes: 'Additional Notes',
      colHost: 'Host',
      colGenomeID: 'Genome ID',
      colID: 'ID',
      colRGenomeID: 'R_Genome ID',
      colSampleID: 'Sample ID',
      colTaxon: 'Taxon',
      colTaxonomy: 'Taxonomy',
      colLevel: 'Level',
      colActions: 'Actions',
      colPhylum: 'Phylum',
      btnDetails: 'Details',
      btnAddFavorite: 'Add to Favorites',
      btnSameTaxon: 'Same Taxon',
      dialogTitle: 'MAG Taxonomy Details',
      dialogLineage: 'Lineage',
      dialogRank: 'Rank',
      rootNode: 'Life',
      msgSelected: 'Selected: {name} ({value} MAGs)',
      msgSelectedFrom: 'Selected {count} MAGs from {level}: {name}',
      msgFilterError: 'Error filtering data',
      msgRenderError: 'Error rendering taxonomy tree',
      viewMAGs: 'View MAGs',
      tooltipCount: 'MAG Count: ',
      tooltipLevel: 'Level: ',
      tooltipPercentage: 'Percentage: ',
      tooltipDepth: 'Depth: ',
      tooltipPath: 'Path: ',
      suffixMAGs: 'MAGs',
      clickToDrillDown: 'Click to drill down',
      unclassified: 'Unclassified',
      others: 'Others',
      phyla: 'Phyla',
      classes: 'Classes',
      orders: 'Orders',
      msgConfirmClearFavorites: 'Are you sure you want to clear all favorite MAGs?',
      msgCancelClear: 'Clear operation cancelled',
      msgAlreadyFavorite: '{id} is already in your favorites',
      msgAddedFavorite: 'Added {id} to favorites',
      msgRemovedFavorite: 'Removed {id} from favorites',
      msgExportFavoritesSuccess: 'Exported {count} favorite MAGs',
      msgExportFavoritesError: 'Failed to export favorites',
      msgAllNodesExpanded: 'All nodes expanded',
      msgExpandError: 'Error expanding nodes',
      msgAllNodesCollapsed: 'All nodes collapsed',
      msgCollapseError: 'Error collapsing nodes',
      msgSelectionCleared: 'Selection cleared',
      msgViewSameTaxon: 'View same taxon for {id}',
      msgExportTaxonFuture: 'Export taxon tree functionality will be implemented',
      levelDomain: 'Domain',
      levelPhylum: 'Phylum',
      levelClass: 'Class',
      levelOrder: 'Order',
      levelFamily: 'Family',
      levelGenus: 'Genus',
      levelSpecies: 'Species',
      msgNoFavorites: 'You have no favorite MAGs yet',
      msgClearedFavorites: 'Cleared all favorite MAGs',
      btnConfirm: 'Confirm',
      btnCancel: 'Cancel',
      msgTreeViewReset: 'Tree view reset',
      msgResetTreeError: 'Error resetting tree view, re-initializing...',
      msgSunburstViewReset: 'Sunburst view reset',
      msgResetSunburstError: 'Error resetting sunburst view, re-initializing...',
      titleSelectedResults: 'Selected Results',
      titleAllResults: 'All Results',
      btnClear: 'Clear',
      placeholderSearch: 'Search by Genome ID, Species, Genus, Family...',
      titleSearch: 'Search & Filter',
      btnSearch: 'Search',
      suffixHosts: 'hosts',
      treeTitle: 'Taxonomic Tree',
      sunburstTitle: 'Taxonomic Sunburst',
      btnExpand: 'Expand',
      btnCollapse: 'Collapse',
      btnReset: 'Reset',
      activeNodes: 'Active Nodes',
      currentLevel: 'Current Level',
      analysisTitle: 'Analysis View',
      viewTable: 'Table View',
      viewTree: 'Tree View',
      viewSunburst: 'Sunburst View',
      distTitle: 'Taxonomic Distribution',
      compTitle: 'Completeness Analysis',
      filterAny: 'Any',
      btnAggView: 'Aggregation View',
      btnShowDetails: 'Show Details',
      btnExport: 'Export',
      aggResults: 'Aggregated Results',
      detailedTaxonomy: 'Detailed Taxonomy',
      totalTaxa: 'Total Taxa: {total}',
      totalMAGs: 'Total MAGs: {total}',
      selected: 'Selected: {count}',
      btnAll: 'Select All',
      btnNone: 'Clear Selection',
      btnFavorites: 'Favorites',
      colMAGCount: 'MAG Count',
      colQualityDist: 'Quality Distribution',
      colHostDiversity: 'Host Diversity',
      btnViewMAGs: 'View MAGs'
    },
    homePage: {
      subTitle: 'A Comprehensive Platform for High-quality Metagenome-assembled Genomes from Wildlife Microbiomes',
      searchPlaceholder: 'Search for species, samples, or metagenomes (e.g., Alces Alces)...',
      searchBtn: 'Search',
      popular: 'Popular:',
      dataOverview: 'Data Overview',
      dataOverviewDesc: 'Global distribution & stats',
      qualityCheck: 'Quality Check',
      qualityCheckDesc: 'Assembly assessments',
      taxonomy: 'Taxonomy',
      taxonomyDesc: 'Species classification',
      function: 'Function',
      functionDesc: 'Gene annotations',
      wildlifeSamples: 'Wildlife Samples',
      uniqueSpecies: 'Unique Species',
      metagenomes: 'Metagenomes',
      missionTitle: 'Advancing Conservation Through Science',
      missionText: 'WHMAGs bridges the gap between genomic science and conservation biology. We provide standardized metagenomic data to help researchers understand the microbial communities of wild Cetacean Artiodactyla, supporting biodiversity protection efforts worldwide.',
      copyright: '© 2025 WHMAGs Database Development Team. All rights reserved.',
      version: 'Version 1.0 (October 2025)'
    },
    dataOverview: {
      loadingTitle: 'Loading MAGs Database...',
      loadingDesc: 'Initializing species data and world map',
      globalDistribution: 'Global Sample Distribution',
      mapHoverTip: 'Hover over points for details',
      mapLoadingTitle: 'Map loading...',
      mapLoadingDesc: 'Fetching geographic data, please wait',
      topCountries: 'Top Countries by Samples',
      speciesOverview: 'Species Overview',
      loadingImages: 'Loading images:',
      viewBtn: 'View',
      samples: 'Samples',
      mags: 'MAGs'
    },
    country: {
      China: 'China',
      Japan: 'Japan',
      NA: 'USA',
      USA: 'USA',
      Germany: 'Germany',
      Tanzania: 'Tanzania',
      Brazil: 'Brazil',
      Unknown: 'Unknown'
    },
    sampleMetadata: {
      statsTitle: 'Sample Statistics',
      statsSubtitle: 'Overview of the database content',
      totalSamples: 'Total Samples',
      hostSpecies: 'Host Species',
      countries: 'Countries',
      bioProjects: 'BioProjects',
      trendText: '+12 this month',
      searchTitle: 'Search & Filter',
      searchSubtitle: 'Find specific samples by metadata',
      keywordPlaceholder: 'Search by Sample ID, Species, Common Name, BioSample, BioProject...',
      searchBtn: 'Search',
      filterCountry: 'Country',
      filterCountryPlaceholder: 'Select Country',
      filterRegion: 'Region',
      filterRegionPlaceholder: 'Select Region',
      filterSpecies: 'Host Species',
      filterSpeciesPlaceholder: 'Select Species',
      filterSource: 'Sample Source',
      filterSourcePlaceholder: 'Select Source',
      filterGender: 'Gender',
      filterGenderPlaceholder: 'Gender',
      genderMale: 'Male',
      genderFemale: 'Female',
      genderUnknown: 'Unknown',
      filterDate: 'Sampling Date',
      dateStart: 'Start',
      dateEnd: 'End',
      applyFilters: 'Apply Filters',
      resetFilters: 'Reset',
      exportResults: 'Export Results',
      preparing: 'Preparing...',
      resultsTitle: 'Metadata Results',
      total: 'Total:',
      selected: 'Selected:',
      btnAll: 'All',
      btnNone: 'None',
      btnFavorites: 'Favorites',
      btnClear: 'Clear',
      colSampleID: 'Sample ID',
      colHostSpecies: 'Host Species',
      colCountry: 'Country',
      colRegion: 'Region',
      colSource: 'Source',
      colGender: 'Gender',
      colDate: 'Date',
      colBioProject: 'BioProject',
      colMAGs: 'MAGs',
      colActions: 'Actions',
      actionDetails: 'Details',
      actionFavorite: 'Add to Favorites',
      actionSearchMAGs: 'Search MAGs',
      actionExport: 'Export Data',
      dialogDetailsTitle: 'Sample Details',
      dialogViewMAGs: 'View MAGs',
      dialogFavorite: 'Favorite',
      dialogBasicInfo: 'Basic Info',
      dialogCommonName: 'Common Name:',
      dialogAge: 'Age:',
      dialogStatus: 'Status:',
      dialogGeography: 'Geography',
      dialogCoordinates: 'Coordinates:',
      dialogMetadata: 'Metadata',
      dialogMAGsList: 'MAGs in Sample',
      colGenomeID: 'Genome ID',
      colCompleteness: 'Completeness',
      colContamination: 'Contamination',
      colQuality: 'Quality',
      linkDetail: 'Detail',
      dialogFavTitle: 'My Favorite Samples',
      btnExportFav: 'Export Favorites',
      btnClearAll: 'Clear All',
      colAddedTime: 'Added Time',
      btnRemove: 'Remove',
      btnView: 'View',
      msgLoadError: 'Failed to load sample data',
      msgDownloadStarted: 'Download started',
      msgNoDataExport: 'No data to export',
      msgExportSuccess: 'Exported {count} records',
      msgExportFailed: 'Export failed',
      msgViewMAG: 'View MAG detail: {id}',
      msgAddedFav: 'Added {id} to favorites',
      msgNoFavs: 'No favorites yet',
      msgRemovedFav: 'Removed {id}',
      msgFavsCleared: 'Favorites cleared',
      msgExportFavs: 'Exported favorites',
      msgExporting: 'Exporting {id}...',
      na: 'N/A',
      confirmExportTitle: 'Export Options',
      confirmExportMessage: 'Export filtered data?',
      btnExportFiltered: 'Export Filtered',
      btnExportAll: 'Export All',
      colType: 'Type',
      colBioSample: 'BioSample',
      colCommonName: 'Common Name',
      colAge: 'Age',
      colStatus: 'Status',
      colLatitude: 'Latitude',
      colLongitude: 'Longitude',
      unknown: 'Unknown',
      sourceFecal: 'Fecal',
      sourceBlood: 'Blood',
      sourceTissue: 'Tissue',
      sourceSkin: 'Skin',
      sourceOral: 'Oral',
      sourceUrine: 'Urine'
    }
  },
  zh: {
    ...elementZhLocale,
    nav: {
      home: '首页',
      dataModule: '数据模块',
      dataOverview: '数据概览',
      sampleMetadata: '样本元数据',
      assemblyQuality: '组装质量',
      taxonomicProfile: '分类学概况',
      dataMonitoring: '数据监控',
      functionModule: '功能模块',
      qualityAssessment: '质量评估',
      speciesAnnotation: '物种注释',
      structuralAnnotation: '结构注释',
      functionalAnnotation: '功能注释',
      resourceSharing: '资源共享',
      userManual: '用户手册',
      contact: '联系我们',
      searchPlaceholder: '快速搜索...',
      subtitle: '野生动物高质量宏基因组组装基因组数据库'
    },
    assemblyQuality: {
      title: '组装统计',
      subtitle: 'MAG 质量指标概览',
      totalMAGs: 'MAG 总数',
      qualityLevel: '质量等级',
      magQuality: 'MAG 质量',
      avgCompleteness: '平均完整度',
      hostSpecies: '宿主物种',
      high: '高',
      medium: '中',
      low: '低',
      chartsTitle: '质量可视化',
      chartsSubtitle: '分布与相关性分析',
      chartDistTitle: '质量等级分布',
      chartScatterTitle: '完整度 vs 污染度',
      filterTitle: '搜索与筛选 MAG',
      filterSubtitle: '通过组装指标查找特定 MAG',
      searchPlaceholder: '搜索基因组 ID, R_Genome ID, 样本 ID, 宿主...',
      searchBtn: '搜索',
      rGenomeId: 'R_Genome ID',
      selectId: '选择 ID',
      selectHost: '选择宿主',
      qualityLevels: '质量等级',
      highQuality: '高质量',
      completeness: '完整度',
      contamination: '污染度',
      genomeSize: '基因组大小 (Mb)',
      gcContent: 'GC 含量 (%)',
      resetFilters: '重置筛选',
      exportSelected: '导出选中',
      tableTitle: '组装结果',
      total: '共: {total} 个 MAG',
      selected: '已选: {count}',
      all: '全选',
      none: '取消',
      favorites: '收藏夹',
      colSampleID: '样本 ID',
      colHost: '宿主',
      colCompleteness: '完整度',
      colContamination: '污染度',
      colQuality: '质量',
      colN50: 'N50 (bp)',
      colSize: '大小 (Mb)',
      colGC: 'GC (%)',
      colActions: '操作',
      btnDetails: '详情',
      btnAddFavorite: '加入收藏',
      btnTaxonomy: '分类学',
      dialogDetailTitle: 'MAG 组装详情',
      btnDownloadFASTA: '下载 FASTA',
      btnFavorite: '收藏',
      tabQuality: '组装质量',
      tabMetrics: '组装指标',
      metaPrimary: '主要元数据',
      metaGenomeID: '基因组 ID:',
      metaSampleID: '样本 ID:',
      metaHost: '宿主物种:',
      metricN50: 'Contig N50',
      metricMaxContig: '最大 Contig',
      metricTotalContigs: 'Contig 总数',
      metricTotalCDS: 'CDS 总数',
      metricCodingDensity: '编码密度',
      metricAvgGeneLength: '平均基因长度',
      dialogFavTitle: '我的收藏 MAG',
      btnExportCSV: '导出 CSV',
      btnClearAll: '清空所有',
      colAdded: '添加时间',
      btnView: '查看',
      btnRemove: '移除',
      msgLoadError: '加载 MAG 数据失败',
      msgAddedFavorite: '已加入收藏'
    },
    taxonomicProfile: {
      title: '分类学统计',
      subtitle: 'MAG 分类指标概览',
      viewTable: '表格视图',
      viewTree: '树形视图',
      viewSunburst: '旭日图',
      analysisTitle: '分类学分析',
      distTitle: '分类分布',
      compTitle: '分类完整度',
      treeTitle: '分类树',
      sunburstTitle: '分类旭日图',
      btnExpand: '展开',
      btnCollapse: '折叠',
      btnReset: '重置',
      activeNodes: '激活节点',
      currentLevel: '当前层级',
      selectedResults: '选中结果',
      allResults: '所有结果',
      btnClear: '清除',
      colID: 'ID',
      colPhylum: '门',
      colLevel: '层级',
      filterTitle: '搜索与筛选',
      searchPlaceholder: '搜索基因组 ID, 物种, 属, 科...',
      searchBtn: '搜索',
      levelDomain: '域',
      levelPhylum: '门',
      levelClass: '纲',
      levelOrder: '目',
      levelFamily: '科',
      levelGenus: '属',
      levelSpecies: '种',
      msgNoFavorites: '您还没有收藏任何 MAG',
      msgClearedFavorites: '已清除所有收藏的 MAG',
      btnConfirm: '确定',
      btnCancel: '取消',
      msgTreeViewReset: '分类树视图已重置',
      msgResetTreeError: '重置分类树时出错，正在重新初始化...',
      msgSunburstViewReset: '旭日图视图已重置',
      msgResetSunburstError: '重置旭日图时出错，正在重新初始化...',
      titleSelectedResults: '已选结果',
      titleAllResults: '所有结果',
      placeholderSearch: '搜索基因组ID、物种、属、科...',
      titleSearch: '搜索与筛选',
      btnSearch: '搜索',
      suffixHosts: '个宿主',
      filterAny: '任意',
      btnAggView: '聚合视图',
      btnShowDetails: '显示详情',
      btnExport: '导出结果',
      aggResults: '聚合结果',
      detailedTaxonomy: '详细分类',
      totalTaxa: '共: {total} 个分类单元',
      totalMAGs: '共: {total} 个 MAG',
      selected: '已选: {count}',
      btnAll: '全选',
      btnNone: '取消',
      btnFavorites: '收藏夹',
      colTaxon: '分类单元',
      colMAGCount: 'MAG 数量',
      axisMAGCount: 'MAG 数量',
      colQualityDist: '质量分布',
      colHostDiversity: '宿主多样性',
      colActions: '操作',
      btnViewMAGs: '查看 MAG',
      colRGenomeID: 'R_Genome ID',
      colSampleID: '样本 ID',
      colTaxonomy: '分类路径',
      btnDetails: '详情',
      btnAddFavorite: '加入收藏',
      btnSameTaxon: '同类 MAG',
      dialogTitle: 'MAG 分类详情',
      dialogLineage: '分类谱系',
      dialogRank: '等级',
      titleConfirm: '确认清除',
      dialogName: '名称',
      msgLoadError: '加载分类数据失败',
      msgExportSuccess: '导出成功',
      classifiedMAGs: '已分类 MAG',
      unclassifiedMAGs: '未分类 MAG',
      taxonomicCoverage: '分类覆盖度',
      speciesLevel: '物种层级',
      msgInitError: '页面初始化失败，请刷新重试',
      msgLoadStatsError: '加载统计数据失败',
      msgNoData: '暂无数据',
      msgExporting: '正在准备导出分类注释数据...',
      msgExportNoData: '没有符合条件的数据可以导出',
      msgExportSuccessCount: '成功导出 {count} 条分类注释数据',
      msgExportError: '获取导出数据失败',
      msgExportFuncError: '导出功能出现错误',
      msgCSVError: '生成CSV文件失败',
      colAdditionalNotes: '备注',
      colHost: '宿主',
      colGenomeID: '基因组 ID',
      rootNode: 'Life',
      msgSelected: '已选择: {name} ({value} 个 MAG)',
      msgSelectedFrom: '已从 {level}: {name} 中选择 {count} 个 MAG',
      msgFilterError: '筛选数据时出错',
      msgRenderError: '渲染分类树时出错',
      viewMAGs: '查看 MAG',
      tooltipCount: 'MAG 数量: ',
      tooltipLevel: '层级: ',
      tooltipPercentage: '百分比: ',
      tooltipDepth: '深度: ',
      tooltipPath: '路径: ',
      suffixMAGs: '个 MAG',
      clickToDrillDown: '点击向下钻取',
      unclassified: '未分类',
      others: '其他',
      phyla: '门',
      classes: '纲',
      orders: '目',
      msgConfirmClearFavorites: '确定要清空所有收藏的 MAG 吗？',
      msgCancelClear: '已取消清空操作',
      msgAlreadyFavorite: '{id} 已在收藏夹中',
      msgAddedFavorite: '已将 {id} 加入收藏',
      msgRemovedFavorite: '已将 {id} 移出收藏',
      msgExportFavoritesSuccess: '已导出 {count} 个收藏的 MAG',
      msgExportFavoritesError: '导出收藏失败',
      msgAllNodesExpanded: '所有节点已展开',
      msgExpandError: '展开节点时出错',
      msgAllNodesCollapsed: '所有节点已折叠',
      msgCollapseError: '折叠节点时出错',
      msgSelectionCleared: '选择已清空',
      msgViewSameTaxon: '查看 {id} 的同类 MAG',
      msgExportTaxonFuture: '导出分类树功能即将上线'
    },
    sampleMetadata: {
      statsTitle: '样本统计',
      statsSubtitle: '数据库内容概览',
      totalSamples: '样本总数',
      hostSpecies: '宿主物种',
      countries: '国家/地区',
      bioProjects: 'BioProjects',
      trendText: '本月新增 +12',
      searchTitle: '搜索与筛选',
      searchSubtitle: '通过元数据查找特定样本',
      keywordPlaceholder: '搜索样本 ID, 物种, 通用名, BioSample, BioProject...',
      searchBtn: '搜索',
      filterCountry: '国家',
      filterCountryPlaceholder: '选择国家',
      filterRegion: '地区',
      filterRegionPlaceholder: '选择地区',
      filterSpecies: '宿主物种',
      filterSpeciesPlaceholder: '选择物种',
      filterSource: '样本来源',
      filterSourcePlaceholder: '选择来源',
      filterGender: '性别',
      filterGenderPlaceholder: '性别',
      genderMale: '雄性',
      genderFemale: '雌性',
      genderUnknown: '未知',
      filterDate: '采样日期',
      dateStart: '开始日期',
      dateEnd: '结束日期',
      applyFilters: '应用筛选',
      resetFilters: '重置',
      exportResults: '导出结果',
      preparing: '准备中...',
      resultsTitle: '元数据结果',
      total: '共:',
      selected: '已选:',
      btnAll: '全选',
      btnNone: '取消',
      btnFavorites: '收藏夹',
      btnClear: '清除',
      colSampleID: '样本 ID',
      colHostSpecies: '宿主物种',
      colCountry: '国家',
      colRegion: '地区',
      colSource: '来源',
      colGender: '性别',
      colDate: '日期',
      colBioProject: 'BioProject',
      colMAGs: 'MAGs',
      colActions: '操作',
      actionDetails: '详情',
      actionFavorite: '加入收藏',
      actionSearchMAGs: '搜索 MAG',
      actionExport: '导出数据',
      dialogDetailsTitle: '样本详情',
      dialogViewMAGs: '查看 MAG',
      dialogFavorite: '收藏',
      dialogBasicInfo: '基本信息',
      dialogCommonName: '通用名:',
      dialogAge: '年龄:',
      dialogStatus: '状态:',
      dialogGeography: '地理位置',
      dialogCoordinates: '坐标:',
      dialogMetadata: '元数据',
      dialogMAGsList: '样本中的 MAG',
      colGenomeID: '基因组 ID',
      colCompleteness: '完整度',
      colContamination: '污染度',
      colQuality: '质量',
      linkDetail: '详情',
      dialogFavTitle: '我的收藏样本',
      btnExportFav: '导出收藏',
      btnClearAll: '清空所有',
      colAddedTime: '添加时间',
      btnRemove: '移除',
      btnView: '查看',
      msgLoadError: '加载样本数据失败',
      msgDownloadStarted: '下载已开始',
      msgNoDataExport: '没有可导出的数据',
      msgExportSuccess: '已导出 {count} 条记录',
      msgExportFailed: '导出失败',
      msgViewMAG: '查看 MAG 详情: {id}',
      msgAddedFav: '已将 {id} 加入收藏',
      msgNoFavs: '暂无收藏',
      msgRemovedFav: '已移除 {id}',
      msgFavsCleared: '收藏已清空',
      msgExportFavs: '已导出收藏',
      msgExporting: '正在导出 {id}...',
      na: '暂无',
      confirmExportTitle: '导出选项',
      confirmExportMessage: '导出筛选后的数据？',
      btnExportFiltered: '导出筛选数据',
      btnExportAll: '导出全部',
      colType: '类型',
      colBioSample: 'BioSample',
      colCommonName: '通用名',
      colAge: '年龄',
      colStatus: '状态',
      colLatitude: '纬度',
      colLongitude: '经度',
      unknown: '未知',
      sourceFecal: '粪便',
      sourceBlood: '血液',
      sourceTissue: '组织',
      sourceSkin: '皮肤',
      sourceOral: '口腔',
      sourceUrine: '尿液'
    },
    homePage: {
      subTitle: '野生动物微生物组高质量宏基因组组装基因组综合平台',
      searchPlaceholder: '搜索物种、样本或宏基因组（例如：驼鹿）...',
      searchBtn: '搜索',
      popular: '热门：',
      dataOverview: '数据概览',
      dataOverviewDesc: '全球分布与统计',
      qualityCheck: '质量检查',
      qualityCheckDesc: '组装质量评估',
      taxonomy: '分类学',
      taxonomyDesc: '物种分类',
      function: '功能',
      functionDesc: '基因注释',
      wildlifeSamples: '野生动物样本',
      uniqueSpecies: '独特物种',
      metagenomes: '宏基因组',
      missionTitle: '以科学推动保护',
      missionText: 'WHMAGs 架起了基因组科学与保护生物学之间的桥梁。我们提供标准化的宏基因组数据，帮助研究人员了解野生鲸偶蹄目的微生物群落，支持全球生物多样性保护工作。',
      copyright: '© 2025 WHMAGs 数据库开发团队。保留所有权利。',
      version: '版本 1.0 (2025年10月)'
    },
    dataOverview: {
      loadingTitle: '正在加载 MAGs 数据库...',
      loadingDesc: '初始化物种数据和世界地图',
      globalDistribution: '全球样本分布',
      mapHoverTip: '悬停查看详情',
      mapLoadingTitle: '地图加载中...',
      mapLoadingDesc: '正在获取地理数据，请稍候',
      topCountries: '样本来源国家排行',
      speciesOverview: '物种概览',
      loadingImages: '加载图片中：',
      viewBtn: '查看',
      samples: '样本',
      mags: 'MAGs'
    },
    country: {
      China: '中国',
      Japan: '日本',
      NA: '美国',
      USA: '美国',
      Germany: '德国',
      Tanzania: '坦桑尼亚',
      Brazil: '巴西',
      Unknown: '未知'
    }
  }
}

const i18n = new VueI18n({
  locale: localStorage.getItem('app_language') || 'en', // set default locale
  messages
})

export default i18n
